import {RaEvent, RaEventType} from "../event/RaEvent";
import {ISelection} from  "../api/data-model";


export class PipelineErrorEvent extends RaEvent {

    static TYPE: RaEventType = "pipeline_error_event";

    constructor(private _message: string) {
        super(PipelineErrorEvent.TYPE);
    }

    public get message(): string {
        return this._message;
    }
}
